"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentWithEntries = void 0;
const common_1 = require("../common");
const entries_1 = require("../entries");
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class AssignmentWithEntries {
    static from(assignmentData, entries) {
        if (!assignmentData || !assignmentData.assignment) {
            return undefined;
        }
        const { assignment } = assignmentData;
        return {
            assignmentId: assignment._id,
            assignment,
            lessonId: assignmentData.meta.lessonId,
            users: (0, common_1.userReferenceFromEntries)(entries),
            numberOfUsers: entries.filter((entry) => entries_1.AssignmentEntry.isActiveEntry(entry)).length,
        };
    }
}
exports.AssignmentWithEntries = AssignmentWithEntries;
//# sourceMappingURL=AssignmentWithEntries.js.map